module.exports = __webpack_public_path__ + "static/media/AUSTRIA.dd9515ba.svg";